import { render } from "./addProduct.vue?vue&type=template&id=2f2b6174"
import script from "./addProduct.vue?vue&type=script&lang=js"
export * from "./addProduct.vue?vue&type=script&lang=js"

import "./addProduct.vue?vue&type=style&index=0&id=2f2b6174&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__